<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";

const {darkMode} = storeToRefs(useNamaFlagsStore());
const props = defineProps({
  fieldsNumber: {type: Number, required: true}
});
</script>

<template>
  <q-card-actions class="tw-flex tw-flex-wrap tw-gap-x-[4%] tw-items-center">
    <template v-for="index in fieldsNumber" :key="index">
      <div class="tw-mb-6 mobile:tw-min-w-full tw-w-[48%] ">
        <q-skeleton type="text" :dark="darkMode" class="tw-w-[25%] tw-h-8"/>
        <q-skeleton type="QInput" :dark="darkMode" class="tw-w-full tw-h-10"/>
      </div>
    </template>
  </q-card-actions>
</template>

<style scoped>

</style>
